/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Consent_SaveInputs */

const da_consent_save = /** @type {(inputs: Consent_SaveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gem mine valg`)
};

/** @type {(inputs: Consent_SaveInputs) => LocalizedString} */
const en_consent_save = da_consent_save;

/**

* @param {Consent_SaveInputs} inputs
* @param {{ locale?: "da" | "en" }} options
* @returns {LocalizedString}
*/
export const consent_save = /** @type {((inputs?: Consent_SaveInputs, options?: { locale?: "da" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Consent_SaveInputs, { locale?: "da" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_consent_save(inputs)
	return /** @type {LocalizedString} */ ("Gem mine valg")
});